import { useState } from "react";
import api from "../lib/apiClient";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Seo from "../components/Seo";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await api.post("/admin/login", { password });
      localStorage.setItem("ts_admin_token", data.token);
      toast.success("WELCOME, COMMANDER.");
      nav("/admin");
    } catch (err) {
      toast.error("WRONG PASSWORD. STAY OUT.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="mx-auto max-w-md px-4 py-24">
      <Seo title="Admin Login" description="TOXIC STREET admin." canonical="https://toxicstreet.co/admin/login" noindex />
      <p className="text-blood text-xs tracking-[0.3em] font-mono">// RESTRICTED</p>
      <h1 className="font-anton uppercase text-bone text-5xl tracking-tighter mt-2">COMMAND CENTER</h1>
      <p className="text-ash text-sm mt-4">Authorized rebels only.</p>
      <form onSubmit={submit} className="mt-10 space-y-4 border border-white/15 p-6">
        <input
          data-testid="admin-password-input"
          type="password"
          autoFocus
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="PASSWORD"
          className="w-full bg-surface border border-white/20 px-4 py-3 text-bone text-sm focus:border-blood focus:outline-none"
        />
        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={submitting}
          className="w-full px-6 py-3 bg-blood text-bone text-xs tracking-[0.3em] uppercase hover:bg-bone hover:text-ink disabled:opacity-50"
        >
          {submitting ? "ENTERING..." : "ENTER →"}
        </button>
      </form>
    </div>
  );
}
